import { render, staticRenderFns } from "./ClientNotePopUp.vue?vue&type=template&id=15eb5124&scoped=true&"
import script from "./ClientNotePopUp.vue?vue&type=script&lang=js&"
export * from "./ClientNotePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eb5124",
  null
  
)

export default component.exports